/**
 * GF closing CTA band (.gf-cta → .gf-cta-in with eyebrow + h2 + actions).
 * Replaces the inline copies across the GF pages. Pass the button(s) as children
 * so each page keeps its own <a>/<Link> / multi-button (.gf-cta-btns) markup.
 *
 * @param {React.ReactNode} eyebrow   small kicker line (.ek)
 * @param {React.ReactNode} title     h2 content
 * @param {string}          className extra classes on the <section> (e.g. 'pr-cta')
 * @param {React.ReactNode} children  action button(s)
 */
export default function GfCta({ eyebrow, title, className = '', children }) {
    return (
        <section className={`gf-cta${className ? ` ${className}` : ''}`}>
            <div className="gf-cta-in">
                {eyebrow && <span className="ek">{eyebrow}</span>}
                <h2>{title}</h2>
                {children}
            </div>
        </section>
    );
}
